var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5067 1.78663C19.0267 1.10663 18.2267 0.666626 17.3333 0.666626L2.66667 0.67996C1.2 0.67996 0 1.86663 0 3.33329V16.6666C0 18.1333 1.2 19.32 2.66667 19.32L17.3333 19.3333C18.2267 19.3333 19.0267 18.8933 19.5067 18.2133L24.7867 10.7733C25.12 10.3066 25.12 9.69329 24.7867 9.22663L19.5067 1.78663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLogo);
export default __webpack_public_path__ + "static/media/skill-logo.28d96c42.svg";
export { ForwardRef as ReactComponent };